import { render, staticRenderFns } from "./jingda.vue?vue&type=template&id=739b6ba7&scoped=true"
var script = {}
import style0 from "./jingda.vue?vue&type=style&index=0&id=739b6ba7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739b6ba7",
  null
  
)

export default component.exports